
/******************************************************************************
	DARK THEME TOGGLE
******************************************************************************/
/*
(function () {
  try {
	var stored = localStorage.getItem('dark');
	var dark = stored !== null
	  ? JSON.parse(stored)
	  : window.matchMedia('(prefers-color-scheme: dark)').matches;

	document.documentElement.classList.toggle('dark', dark);
  } catch (e) {}
})();
*/

/******************************************************************************
	(VISUAL) PASSWORD VALIDATOR
******************************************************************************/
(function() {

	const pass1 = document.querySelector('input[name="pass1"]');
	const pass2 = document.querySelector('input[name="pass2"]');
	const rules = document.getElementById('pw_rules');

	if (!pass1 || !pass2 || !rules) return;

	const r = (key) => rules.querySelector('[data-rule="' + key + '"]');

	const hasUpper = s => /[A-Z]/.test(s);
	const hasLower = s => /[a-z]/.test(s);
	const hasDigit = s => /\d/.test(s);
	const hasSpecial = s => /[^A-Za-z0-9]/.test(s);

	function setState(el, ok) {
		el.classList.remove('text-gray-400', 'text-red-400', 'bg-green-100', 'valid', 'invalid');
		el.classList.add(ok ? 'bg-green-100' : 'text-gray-400');
		el.classList.add(ok ? 'valid' : 'invalid');
	}

	function validate() {

		const p1 = pass1.value || '';
		const p2 = pass2.value || '';

		// Wenn Passwort leer → alles neutral anzeigen
		if (!p1) {
			rules.querySelectorAll('li').forEach(li => {
				li.classList.remove('valid','invalid','bg-green-100','text-red-500');
				li.classList.add('text-gray-400','invalid');
			});
			pass1.setCustomValidity('');
			pass2.setCustomValidity('');
			return;
		}

		const checks = {
			length: p1.length >= 8,
			upper: hasUpper(p1),
			lower: hasLower(p1),
			digit: hasDigit(p1),
			special: hasSpecial(p1),

			// FIX: nur prüfen/anzeigen wenn pass2 überhaupt genutzt wird
			match: (p2 !== '') ? (p1 === p2) : null
		};

		// Anzeige: null => neutral, true => grün, false => neutral (oder rot wenn du willst)
		Object.entries(checks).forEach(([key, ok]) => {
			const el = r(key);
			if (!el) return;

			if (ok === null) {
				el.classList.remove('valid', 'invalid');
				el.classList.remove('bg-green-100', 'text-red-400');
				el.classList.add('text-gray-400');
				el.classList.add('invalid');
				return;
			}

			setState(el, ok);
		});


		// Browser native validation
		const policyValid =
			checks.length &&
			checks.upper &&
			checks.lower &&
			checks.digit &&
			checks.special;

		pass1.setCustomValidity(policyValid ? '' : MMQGUEST.lang.PasswordRequirementsNnotFulfilled);

		// CustomValidity: nur setzen, wenn pass2 befüllt ist
		if (p2 === '') {
		  pass2.setCustomValidity('');
		} else {
		  pass2.setCustomValidity(p1 === p2 ? '' : MMQGUEST.lang.PasswordsDoNotMatch);
		}

	}

	pass1.addEventListener('input', validate);
	pass2.addEventListener('input', validate);

	const form = pass1.closest('form');
	if (form) {
		form.addEventListener('submit', function(e) {
			validate();
			if (!form.checkValidity()) {
				e.preventDefault();
				form.reportValidity();
			}
		});
	}

})();





Alpine.data("app", (initial = {}) => ({
	dark: false,

	canUseDarkMode() {
		return !document.body.classList.contains('page-id-2');
	},

	initTheme() {
		const stored = localStorage.getItem('dark');
		const wantsDark = stored !== null ? JSON.parse(stored) : false;

		this.darkMode = this.canUseDarkMode() ? wantsDark : false;
		document.documentElement.classList.toggle('dark', this.darkMode);
	},

	toggleTheme() {
		if (!this.canUseDarkMode()) {
			this.darkMode = false;
			localStorage.setItem('dark', 'false');
			document.documentElement.classList.remove('dark');
			return;
		}

		this.darkMode = !this.darkMode;
		localStorage.setItem('dark', JSON.stringify(this.darkMode));
		document.documentElement.classList.toggle('dark', this.darkMode);
	},

	/*
	initTheme() {
		const stored = localStorage.getItem('dark');
		this.dark = stored !== null ?
			JSON.parse(stored) :
			window.matchMedia('(prefers-color-scheme: dark)').matches;
	},

	toggleTheme() {
		this.dark = !this.dark;
		localStorage.setItem('dark', JSON.stringify(this.dark));
	},
	*/

	// ...deine restlichen States/Methoden HIER rein (ohne extra return)
	isSideMenuOpen: false,
	toggleSideMenu() { this.isSideMenuOpen = !this.isSideMenuOpen; },
	closeSideMenu() { this.isSideMenuOpen = false; },

	isProfileMenuOpen: false,
	toggleProfileMenu() { this.isProfileMenuOpen = !this.isProfileMenuOpen; },
	closeProfileMenu() { this.isProfileMenuOpen = false; },

	isPagesMenuOpen: initial.isPagesMenuOpen ?? false,
	togglePagesMenu() { this.isPagesMenuOpen = !this.isPagesMenuOpen; },


}));

